/**
 * Created by staffanrantzow on 15/03/16.
 */

/* @flow */
import React, {PropTypes } from 'react';
import LeftSection from '../../components/left-page-section/left-page-section';
import InfoBoxList from 'components/left-page-section/info-box/info-box-list';

export class PageWrapper extends React.Component {

  static propTypes = {
    location: PropTypes.object.isRequired,
    children: PropTypes.object,
    user: PropTypes.object.isRequired,
    taxkeys: PropTypes.array.isRequired
  };

  static childContextTypes = {
    user: React.PropTypes.object,
    taxkeys: React.PropTypes.array
  };

  constructor (props, context) {
    super(props, context);

    this.state = {
      user: props.user,
      taxkeys: props.taxkeys
    };
  }

  componentWillReceiveProps (nextProps) {
    this.setState({
      user: nextProps.user,
      taxkeys: nextProps.taxkeys
    });
  }

  getChildContext () {
    return {
      user: this.state.user,
      taxkeys: this.state.taxkeys
    };
  }

  render () {
    return (
      <div className='container page'>
        <div className='row'>
          <div className="col-sm-12">
            <div className='left-column'>
              <LeftSection currentPath={this.props.location.pathname} />
            </div>
            <div className='right-column page-content'>
              {this.props.children || 'Welcome to your PageWrapper'}
              <InfoBoxList />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PageWrapper;




/** WEBPACK FOOTER **
 ** ./src/layouts/page-wrapper/page-wrapper.js
 **/